export default "__VITE_ASSET__7YUrMXJo__"